import {
  AccordionItem,
  Text,
  List,
  Stack,
  Heading,
  Strong,
} from 'braid-design-system';
export const SectionC = () => (
  <AccordionItem id="section-c" label="Section C: Ad Selection Panel">
    <Stack space="gutter">
      <Heading level="4">Functional</Heading>
      <List type="number" start={74}>
        <Text>
          Section C applies if you have chosen to use the Panel functionality
          through the SEEK API.
        </Text>
        <Text>
          <Strong>Panel</Strong> means an Ad Selection Panel which is an
          embeddable widget that you can place in your posting flow to retrieve
          available ad products during advertisement creation and modification.
        </Text>
        <Stack space="medium">
          <Text>You acknowledge and agree that:</Text>
          <List type="alpha">
            <Text>
              if you choose to utilise the Panel, it must be made available to
              all Advertisers. Removal of the Panel for any Advertiser must be
              discussed and agreed with us beforehand;
            </Text>
            <Text>
              all SEEK Group products available through the Panel must be
              visible and accessible to all Advertisers;
            </Text>
            <Text>
              you will make reasonable endeavours to load the Panel on the page
              within 1 second;
            </Text>
            <Stack space="medium">
              <Text>
                pricing information surfaced via the Panel is not to be used for
                any other purpose other than for displaying:
              </Text>
              <List type="roman">
                <Text>
                  the price of our products to Advertisers who are posting job
                  ads in the flow;
                </Text>
                <Text>job posting spend analysis, and</Text>
                <Text>
                  other relevant reporting and management information.
                </Text>
              </List>
            </Stack>
          </List>
        </Stack>
      </List>
      <Heading level="4">Messaging / Branding</Heading>
      <List type="number" start={77}>
        <Text>
          You must not change or modify any design elements related to the
          Panel, unless we have provided consent for you to do so.
        </Text>
        <Text>
          If you believe an element of the design is sub-optimal for your users,
          you may request a design change by contacting us, which we will
          consider in our sole discretion.
        </Text>
      </List>
    </Stack>
  </AccordionItem>
);
